import { createQueryString } from '@eika-infrastruktur/utils';

import type {
    PaymentAgreementId,
    ApprovalResult,
    RecurringPaymentAgreement,
    RecurringPaymentAgreementRequest,
} from '../generated-types';
import { CONTEXT_PATH } from './index';
import { del, get, post, put } from './request';

const SERVICE_PATH = 'rest/resource/recurringpayments';

export function getRecurringPayments(): Promise<RecurringPaymentAgreement[]> {
    return get<RecurringPaymentAgreement[]>(`${CONTEXT_PATH}/${SERVICE_PATH}`);
}

export function createRecurringPaymentAgreement(
    recurringPaymentRequest: RecurringPaymentAgreementRequest,
): Promise<ApprovalResult> {
    return post<ApprovalResult>(`${CONTEXT_PATH}/${SERVICE_PATH}`, recurringPaymentRequest);
}

export function updateRecurringPaymentAgreement(
    paymentAgreementId: PaymentAgreementId,
    recurringPaymentRequest: RecurringPaymentAgreementRequest,
): Promise<ApprovalResult> {
    return put<ApprovalResult>(`${CONTEXT_PATH}/${SERVICE_PATH}/${paymentAgreementId}`, recurringPaymentRequest);
}

export function deleteRecurringPaymentAgreement(paymentAgreementId: PaymentAgreementId): Promise<ApprovalResult> {
    const queryString = createQueryString({
        deviceId: window.ReactNativeProps?.deviceId,
    });

    return del(`${CONTEXT_PATH}/${SERVICE_PATH}/${paymentAgreementId}${queryString}`);
}
